import { NgModule } from '@angular/core';
import { FcpModalComponent } from './fcp-modal.component';
import { CommonModule } from '@angular/common';
import { DialogModule } from '@angular/cdk/dialog';
import { FcpDialogComponent } from './fcp-dialog.component';
import { FcpButtonModule } from '../fcp-button';
import { FcpIconModule } from '../fcp-icon';

@NgModule({
    declarations: [FcpModalComponent, FcpDialogComponent],
    exports: [FcpModalComponent],
    imports: [CommonModule, DialogModule, FcpButtonModule, FcpIconModule]
})
export class FcpModalModule {}
